<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label class="label-chk">
        <label class="label-chk bold form-label-custom">
          <input
            #inputEl
            type="checkbox"
            [(ngModel)]="agreedToTermsCondition"
            (change)="onChange(inputEl.checked)"
          />
          I have read and agree to the
        </label>
        <a
          class="redify bold form-label-custom ml-1"
          href="javascript:void(0)"
          (click)="openModal()"
        >
          Terms and Conditions</a
        ><br />
      </label>
    </div>
  </div>
</div>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div
  class="modal custom-modal-terms"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: display }"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="onCloseHandled()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Terms and Conditions</h4>
      </div>
      <div class="modal-body" [innerHTML]="tc_content | safeHtml: 'html'"></div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default"
          (click)="onCloseHandled()"
        >
          Close
        </button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal !-->
